import { readBuildTimeRuntimeEnv } from './buildTimeEnv';
import { resolveRuntimeEnvWithFallbacks, type RuntimeEnvironment } from './runtimeConfig';

// Single source of truth for env resolution across the app (login + authenticated
// requests) — runtime browser override wins, build-time injected constants fall back.
export const resolveClientEnv = (): RuntimeEnvironment =>
  resolveRuntimeEnvWithFallbacks({
    runtimeEnv: window.__FIELD_OPS_ENV__,
    fallbackEnv: readBuildTimeRuntimeEnv(),
  });
